// extracted by mini-css-extract-plugin
export default {"container":"style_container__zounn","attr":"style_attr__mcfJ7"};